
function getPath(){
    var js = document.scripts, script = js[js.length - 1], jsPath = script.src;
    return jsPath.substring(0, jsPath.lastIndexOf("/") + 1);
}
/**
 * 获取 自身路径
 * @returns {string}
 */
module.exports = function () {
    var path = '';
    if(typeof trfLoader !=='undefined'){
        path = trfLoader.toUrlPath('trf')
    }else if(typeof document !=='undefined'){
        path = getPath();
    }
    return path;
};


//////////////////
// WEBPACK FOOTER
// ./src/core/_path.js
// module id = 195
// module chunks = 0